import React from 'react';
import { NumberInput, DropdownSelector } from 'hyperdb-utils';

const PriceExtraGuestsForm = (props) => {
  const extraPeopleOptions = (extraPeople) => {
    const options = [];
    for (let i = 1; i <= extraPeople; i++) {
      options.push({ name: i, value: i });
    }
    return options;
  };
  return (
    <form>
      <fieldset>
        <DropdownSelector
          label="Nb extra guests"
          name="nb_extra_guests"
          value={ props.params.nb_extra_guests }
          options={ extraPeopleOptions(props.extraPeople) }
          onChange={ props.onChange.bind(null, 'nb_extra_guests') }
        />
        <NumberInput
          label="Charge"
          name="charge"
          value={ props.params.charge }
          onChange={ props.onChange.bind(null, 'charge') }
        />
      </fieldset>
    </form>
  );
};

PriceExtraGuestsForm.propTypes = {
  params: React.PropTypes.object,
  onChange: React.PropTypes.func,
};

export default PriceExtraGuestsForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/PriceExtraGuestsForm.jsx